import CalendarEventKeyRange from '../../store/schema/CalendarEventKeyRange';
import CalendarFetchOrder from '../../store/schema/CalendarFetchOrder';
import { CalendarEvent } from 'mini-calendar-event-types';
import { getCalendarEventKeyIndex, getCalendarEventsStore } from '../../store/store';

/**
 * Internal method that gets calendar events from cache based on range and max count requested.
 * @param range - Calendar key range between which we should consider the events to return.
 * @param order - Should the N events be returned from the front or end of specified range.
 * @param maxEventsCount - maximum number of events to return.
 * @returns Array of calendar events based on the request.
 */
export default function getCalendarEventsFromCache(
    range: CalendarEventKeyRange,
    order: CalendarFetchOrder = CalendarFetchOrder.Ascending,
    maxEventsCount?: number
): CalendarEvent[] {
    let eventsInRange: CalendarEvent[] = getCalendarEventKeyIndex().getCalendarEvents(range);

    const eventsStore = getCalendarEventsStore();
    eventsInRange = eventsInRange.filter(
        event => !!(event && event.ItemId && eventsStore.getCalendarEvent(event.ItemId.Id))
    );

    if (!maxEventsCount) {
        // return all.
        return eventsInRange;
    } else {
        if (eventsInRange.length <= maxEventsCount) {
            // return all events found.
            return eventsInRange;
        } else {
            return order === CalendarFetchOrder.Ascending
                ? eventsInRange.slice(0, maxEventsCount)
                : eventsInRange.slice(eventsInRange.length - maxEventsCount, eventsInRange.length);
        }
    }
}
